export const calculateFontSize = (textbox) => {
    const textObj = textbox;
    if (!textObj || textObj.type !== 'textbox')
        return;
    if (textObj.scaleX == 1)
        return;
    const originalFontSize = textObj.fontSize || 16;
    const originalScaleX = textObj.scaleX || 1;
    // Calculate new font size based on scale
    const scaleFactor = Math.abs(originalScaleX);
    const newFontSize = Math.round(originalFontSize * scaleFactor);
    const minFontSize = 10;
    const maxFontSize = 1000;
    const clampedFontSize = Math.min(Math.max(newFontSize, minFontSize), maxFontSize);
    const widthScaleFactor = clampedFontSize / originalFontSize;
    const newWidth = textObj.width * widthScaleFactor;
    textObj.set({
        fontSize: clampedFontSize,
        width: newWidth,
        scaleX: 1,
        scaleY: 1,
        scaleFactor: scaleFactor,
    });
};
